import * as React from 'react';
import { useState } from 'react';
import MobileCard from 'src/components/mobile/MobileCard';
import classNames from 'classnames';
import styles from '../../../assets/case-component-tab.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlusCircle,
    faLongArrowAltLeft,
    faAngleDoubleUp,
    faAngleDoubleDown,
    faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';

import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Paginated } from 'src/services/api-handlers/pagination';
import { ISeance } from 'src/types/seance';
import { ICase } from 'src/types/case';
import { groupInvoiceToCsv } from 'src/helpers/seance/groupSeanceCsv';
import ModalComponent from './ModalComponent';
import { useDispatch, useSelector } from 'react-redux';
import { QueryParams } from 'src/types/grid';
import { getRowsSession, getRowsSessionManual } from '../helpers/index';

import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { IProvider } from '../../../../../../../../../types/provider';
import groupModal from '../helpers/groupModal';
import Router from '../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../navigation';
import { StoreState } from '../../../../../../../../../store/reducers';

interface RouteParams {
    id: string;
    subId: string;
}

export interface Props extends RouteComponentProps<RouteParams> {
    data: Paginated<ISeance>;
    provider: Partial<IProvider> | null;
    //dataProgramBooks: any;
    caseCurrent: ICase | null;
    inProgressInvoice: boolean;
    statusEnum: any;
    month: { monthEnd: string; monthStart: string };
    updateSeance: (status: number, id: string, setPopup: (param: boolean) => void) => void;
    cases: Paginated<ICase>;
    seances: Paginated<ISeance>;
    seancesList: Paginated<ISeance>;
    serviceTypes: SelectObject[];
    serviceLocations: SelectObject[];
    getData: (params: QueryParams) => void;
    createInvoiceAction: (params: any, setPopup: (param: boolean) => void) => void;
    createStatementAction: (params: any, setPopup: (param: boolean) => void) => void;
    existData?: any;
    setExistData?: any;
    dataSaveModal?: any;
    setSaveModal?: any;
    valueOrderTypeLabel?: any;
    setValueOrderTypeLabel?: any;
}

const SessionTable: React.FunctionComponent<Props> = ({
    match: {
        params: { id },
    },
    caseCurrent,
    cases,
    statusEnum,
    provider,
    //dataProgramBooks,
    serviceLocations,
    serviceTypes,
    createInvoiceAction,
    createStatementAction,
    updateSeance,
    getData,
    month,
    data,
    seances,
    seancesList,
    existData,
    setExistData,
    dataSaveModal,
    setSaveModal,
    valueOrderTypeLabel,
    setValueOrderTypeLabel,
}: Props) => {
    const [opened, setOpened] = useState(-5);
    const [isRate, setRatePer] = useState<boolean>(false);
    const [formColumn, setFormColumn] = useState<any>(false);
    const [popup, setPopup] = useState<boolean>(false);

    const [currentAction, setCurrentAction] = useState<string>('SIGN');
    const [manualAction, setManualAction] = useState<{} | boolean>(false);
    const [currentActionData, setCurrentActionData] = useState<any>({});

    const [start, setStart] = useState<string>('');
    const [end, setEnd] = useState<string>('');

    const dataProgramBooks = useSelector((state: StoreState) => state.programBooks.data);
    const dataProgramBooksInProgress = useSelector((state: StoreState) => state.programBooks.inProgress);

    const dispatch = useDispatch();

    const caseValues: SelectObject[] = [];

    cases.list.forEach((cas: Partial<ICase>) => {
        caseValues.push({ value: `${cas.id}`, label: `${cas.id}` });
    });
    const isProvider =
        !user.getRoles().includes(UserRole.ROLE_ADMIN) && provider?.userProviders && !provider.userProviders.length;
    const signArr: any = [];
    if (!isProvider) {
        signArr.push({ id: 'signDoc', label: 'Sign Doc', cellStyle: 'normal' });
    }
    const entityModal: any = groupModal({
        dispatch,
        currentActionData,
        setPopup,
        updateSeance,
        createInvoiceAction,
        caseCurrent,
        id,
        month,
        createStatementAction,
        setCurrentActionData,
        setCurrentAction,
        setEnd,
        setStart,
    });
    const { totalPages, page } = data;
    const canInvoice = true;
    let dataSessionComponents: any = [];
    if (Object.values(statusEnum).length) {
        if (manualAction) {
            dataSessionComponents = getRowsSessionManual(data.list, {
                id,
                caseCurrent,
                canInvoice,
                statusEnum,
                setManualAction,
                manualAction,
            });
        } else {
            dataSessionComponents = getRowsSession(data.list, {
                formColumn,
                provider,
                month,
                dispatch,
                setRatePer,
                statusEnum,
                isRate,
                serviceLocations,
                serviceTypes,
                id,
                caseCurrent,
                canInvoice,
                setCurrentAction,
                setOpenDrop: (some) => false,
                setPopup,
                setCurrentActionData,
                caseValues,
                setFormColumn,
                existData,
                setExistData,
                dataSaveModal,
                setSaveModal,
                valueOrderTypeLabel,
                setValueOrderTypeLabel,
            });
        }
    }

    /*    const some = React.useMemo(() => {

    }, [data.list.length, caseCurrent?.id, opened, popup, formColumn, month, isRate, canInvoice, openDrop]);*/

    const dataAdd = [];
    if (caseCurrent?.district) {
        dataAdd.push({ id: 'seanceInfo', label: 'Student Addition', cellStyle: 'normal' });
    }

    const dataCaseArr = [];
    if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        dataCaseArr.push({ id: 'toCase', label: 'Case', cellStyle: 'normal' });
    }

    const RatePerArr = [];
    if (isRate) {
        RatePerArr.push({ id: 'externalRatePerHour', label: 'External Rate per Hour', cellStyle: 'normal' });
        RatePerArr.push({ id: 'externalRatePerUnit', label: 'External Rate per Unit', cellStyle: 'normal' });
        RatePerArr.push({ id: 'internalRatePerHour', label: 'Internal Rate per Hour', cellStyle: 'normal' });
        RatePerArr.push({ id: 'internalRatePerUnit', label: 'Internal Rate per Unit', cellStyle: 'normal' });
    }

    return (
        <div className={'d-flex flex-column'}>
            <div className={classNames(styles.wrapBtns)}>
                <div className={classNames(styles.columnWrapBtn)}>
                    {' '}
                    {manualAction ? (
                        <button
                            className={classNames(
                                styles.btnHeight,
                                styles.buttonColumn,
                                styles.buttonColumnInv,
                                styles.backBtn,

                                'mb-3',
                            )}
                            type={'button'}
                            onClick={() => setManualAction(false)}
                        >
                            <FontAwesomeIcon className={'mr-1'} icon={faLongArrowAltLeft} />
                        </button>
                    ) : (
                        ''
                    )}
                    {data.list.length ? (
                        isProvider ? null : (
                            <button
                                type={'button'}
                                className={classNames(styles.btnHeight, `btn btn-outline-info`)}
                                onClick={() => {
                                    groupInvoiceToCsv(data.list);
                                }}
                            >
                                Export .csv
                            </button>
                        )
                    ) : null}
                    {canInvoice && data.list.length ? (
                        <div>
                            {caseCurrent && +caseCurrent?.caseType === 2 ? (
                                <div className={classNames(styles.wrapBtn)}>
                                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                                        <button
                                            className={classNames(
                                                styles.btnFlex,
                                                styles.btnHeight,
                                                'btn btn-outline-info ',
                                            )}
                                            type={'button'}
                                            onClick={() => {
                                                setCurrentAction('STATEMENT_DONE');
                                                setPopup(true);
                                                setCurrentActionData({
                                                    seanceDateFrom: month.monthStart,
                                                    seanceDateTo: month.monthEnd,
                                                });
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faCheckCircle} /> <div>Statement</div>
                                        </button>
                                    ) : null}
                                    <button
                                        className={classNames(styles.btnHeight, 'btn btn-outline-info  ')}
                                        type={'button'}
                                        onClick={() => {
                                            setCurrentAction('INVOICE_DONE');
                                            setPopup(true);
                                            setCurrentActionData({
                                                seanceDateFrom: month.monthStart,
                                                seanceDateTo: month.monthEnd,
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faCheckCircle} /> <div>Invoice</div>
                                    </button>
                                </div>
                            ) : (
                                <button
                                    className={classNames(styles.btnHeight, 'btn btn-outline-info ')}
                                    type={'button'}
                                    onClick={() => {
                                        setCurrentAction('INVOICE');
                                        setPopup(true);
                                    }}
                                >
                                    <div>Make Invoice</div>
                                </button>
                            )}
                        </div>
                    ) : null}
                </div>

                <div className={classNames(styles.btns)} style={{ marginBottom: '0px' }}>
                    {!manualAction ? (
                        <div className={classNames(styles.columnWrapBtn)}>
                            {user.getRoles().includes(UserRole.ROLE_ADMIN) && (
                                <button
                                    className={classNames(
                                        styles.btnHeight,
                                        styles.manualInvoice,
                                        'btn btn-outline-info ',
                                    )}
                                    type={'button'}
                                    onClick={() => {
                                        setManualAction({});
                                    }}
                                >
                                    <div>Make Invoice Manual</div>
                                </button>
                            )}
                            <div className={'d-flex'}>
                                <button
                                    className={classNames(
                                        styles.btnHeight,
                                        styles.sessionBtn,
                                        styles.btnPlus,
                                        'btn btn-outline-info',
                                    )}
                                    type={'button'}
                                    onClick={() => {
                                        setOpened(0);
                                        setFormColumn(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} /> <div>Add Session</div>
                                </button>
                            </div>
                        </div>
                    ) : (
                        <button
                            className={classNames(styles.btnHeight, styles.buttonColumn, styles.buttonColumnInv)}
                            type={'button'}
                            disabled={!!Object.keys(manualAction).length}
                            onClick={() => {
                                const arrSend: number[] = [];
                                Object.keys(manualAction).forEach((it: number | string) => {
                                    arrSend.push(+it);
                                });
                                createInvoiceAction(
                                    {
                                        id: caseCurrent?.id,
                                        providerId: +id,
                                        sessions: arrSend,
                                    },

                                    setManualAction,
                                );
                            }}
                        >
                            <div>Make Invoice Manual</div>
                        </button>
                    )}
                </div>
            </div>
            <div className={classNames(styles.wrapBtns)}>
                <div className={classNames(styles.columnWrapBtn)}>
                    {dataProgramBooks.list.length ? (
                        <Link
                            to={Router.generate(routes.PROGRAM_BOOK_DETAIL, {
                                id: dataProgramBooks.list[0].id,
                            })}
                            type={'button'}
                            className={'case-component-tab_btnHeight__NoYmx btn btn-outline-info'}
                            target={'_blank'}
                        >
                            Program Book Results
                        </Link>
                    ) : null}
                </div>
                {!dataProgramBooksInProgress ? (
                    dataProgramBooks.list.length ? (
                        <div className={classNames(styles.btns)}>
                            <Link
                                to={Router.generate(routes.PROGRAM_BOOK_EDIT, {
                                    id: dataProgramBooks.list[0].id,
                                })}
                                type={'button'}
                                className={'case-component-tab_btnHeight__NoYmx btn btn-outline-info'}
                            >
                                Edit Program Book
                            </Link>
                        </div>
                    ) : (
                        <div className={classNames(styles.btns)}>
                            <Link
                                to={Router.generate(routes.PROGRAM_BOOK_CREATE, {
                                    id: caseCurrent?.orderEntity?.student?.id
                                        ? caseCurrent?.orderEntity?.student?.id
                                        : caseCurrent?.student?.id,
                                })}
                                type={'button'}
                                className={'case-component-tab_btnHeight__NoYmx btn btn-outline-info'}
                            >
                                Edit Program Book
                            </Link>
                        </div>
                    )
                ) : null}
            </div>

            <MobileCard
                type={'session'}
                action={(val) => {
                    setFormColumn(val);
                    if (!val) {
                        setOpened(-5);
                    }
                }}
                opened={opened}
                setOpened={setOpened}
                setManualAction={setManualAction}
                manualAction={manualAction}
                data={dataSessionComponents}
                getData={(data) => {
                    getData({
                        filters: {
                            'occasion.id': caseCurrent?.id,
                            'provider.id': id,
                        },
                        ...data,
                    });
                }}
                pagination={{ page, totalPages }}
                columns={[
                    { id: 'action', label: 'Action', cellStyle: 'normal' },
                    { id: 'id', label: 'Note ID', cellStyle: 'normal' },
                    ...dataCaseArr,
                    { id: 'status', label: 'Status', cellStyle: 'normal' },
                    { id: 'serviceType', label: 'Service Type', cellStyle: 'normal' },
                    { id: 'serviceLocation', label: 'Service Location', cellStyle: 'normal' },
                    { id: 'minPerUnit', label: 'Min Per Unit', cellStyle: 'normal' },
                    ...dataAdd,
                    { id: 'seanceDate', label: 'Session Date', cellStyle: 'miw100' },
                    { id: 'startTime', label: 'Start Time', cellStyle: 'miw80' },
                    { id: 'endTime', label: 'End Time', cellStyle: 'miw80' },
                    { id: 'datasheet', label: 'PBook', cellStyle: 'miw80' },
                    ...RatePerArr,
                    { id: 'totalUnit', label: 'Total Units', cellStyle: 'normal' },
                    { id: 'totalFee', label: 'Total Fee', cellStyle: 'normal' },
                    ...signArr,
                    {
                        id: 'rate',
                        label: (
                            <FontAwesomeIcon
                                onClick={() => {
                                    setRatePer(!isRate);
                                }}
                                icon={isRate ? faAngleDoubleUp : faAngleDoubleDown}
                            />
                        ),
                        cellStyle: 'btnCell',
                    },
                ]}
            />

            <ModalComponent
                modal={popup}
                setModal={setPopup}
                dataBody={entityModal[currentAction]?.body}
                action={entityModal[currentAction]?.action}
            />
        </div>
    );
};

export default withRouter(SessionTable);
